export default "__VITE_ASSET__mAMPeH2T__"